import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Button, Table, Space, notification } from "antd";
import { getUsers, updateUser } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import AddUserCode from "./AddUserCode";

import "./User.css";

function User({ navStore, authStore }) {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Organization",
      dataIndex: "organization",
      key: "organization",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space>
          {record.status == "INVITED" && (
            <a onClick={() => resendInvitation(record)}>Resend</a>
          )}
        </Space>
      ),
    },
  ];

  useEffect(() => {
    navStore.selectedKey = "3";
    setLoading(true);
    getUsers().then((res) => {
      const users = res.map((x) => {
        const key = x.id;
        const name = `${x.firstname} ${x.lastname}`;
        const email = x.email;
        const organization = x.organization_details?.name;
        const role = x.roles.length > 0 ? x.roles[0].role : "";
        const status = x.status;
        return {
          key,
          email,
          name,
          organization,
          role,
          status,
        };
      });
      setUsers(users);
      setLoading(false);
    });
  }, []);

  const resendInvitation = async (record) => {
    await updateUser(
      record.email,
      record.firstname,
      record.lastname,
      record.organization,
      record.role,
      true
    );
    notification.open({
      message: "Invitation resent",
      description: "Invitation resent Successfully",
    });
  };

  return (
    <div className="User">
      <div className="seperator">
        {!loading && ["admin", "org_admin"].indexOf(authStore.userRole) >= 0 && (
          <Button
            type="primary"
            style={{ float: "right" }}
            onClick={() => navigate("/organization/user/add")}
          >
            Add User
          </Button>
        )}
      </div>
      {loading && <LoadingSpinner />}
      {!loading && <Table dataSource={users} columns={columns} />}
      {!loading &&
        authStore.user &&
        ["org_admin"].indexOf(authStore.userRole) >= 0 && (
          <AddUserCode
            selectedOrg={authStore.user.organization_details.id}
          ></AddUserCode>
        )}
    </div>
  );
}

export default observer(User);
